import { useState, useEffect } from "react";
import { api } from "./Api"; // ton instance Axios

export default function NoticeModal({ open, onClose }) {
    const [notice, setNotice] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            setLoading(true);
            api.get("/notice")
                .then((res) => {
                    setNotice(res.data.notice);
                })
                .catch((err) => {
                    console.error(err);
                    setNotice(err.response?.data?.message || "Erreur lors du chargement");
                })
                .finally(() => setLoading(false));
        }
    }, [open]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50 p-4">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl w-full max-w-7xl max-h-[80vh] shadow-lg relative overflow-hidden">
                <button
                    onClick={onClose}
                    className="absolute top-2 right-3 text-gray-400 hover:text-gray-600"
                >
                    ✕
                </button>
                <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Notice</h2>
                {loading ? (
                    <p className="text-gray-700 dark:text-gray-300">Chargement...</p>
                ) : (
                    <pre className="text-sm whitespace-pre-wrap text-gray-800 dark:text-gray-200 overflow-auto max-h-[60vh]">{notice}</pre>
                )}
            </div>
        </div>
    );
}
